import { render, staticRenderFns } from "./uploadLogo.vue?vue&type=template&id=3a9fd8ec&"
import script from "./uploadLogo.vue?vue&type=script&lang=ts&"
export * from "./uploadLogo.vue?vue&type=script&lang=ts&"
import style0 from "./uploadLogo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports